import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import SetNewPassword from './pages/SetNewPassword';
import Signup from './pages/Signup';
import Unauthorized from './pages/Unauthorized';
import Dashboard from './pages/Dashboard';
import LeadQualityScore from './pages/LeadQualityScore';
import InstagramScheduler from './pages/InstagramScheduler';
import ShootPlans from './pages/ShootPlans';
import ShootPlanWizard from './pages/wizard/ShootPlanWizard';
import Feedback from './pages/Feedback';
import Brands from './pages/Brands';
import Team from './pages/Team';
import Freelancers from './pages/Freelancers';
import Models from './pages/Models';

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/set-new-password" element={<SetNewPassword />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Every department lands here after login. */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* Admin-only account creation -- reuses the original Signup
                form/logic, just no longer publicly reachable at /signup. */}
            <Route
              path="/create-account"
              element={
                <AdminRoute>
                  <Signup />
                </AdminRoute>
              }
            />

            <Route
              path="/lead-quality-score/*"
              element={
                <ProtectedRoute>
                  <LeadQualityScore />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instagram-scheduler/*"
              element={
                <ProtectedRoute>
                  <InstagramScheduler />
                </ProtectedRoute>
              }
            />

            <Route
              path="/shoot-plans"
              element={
                <ProtectedRoute>
                  <ShootPlans />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shoot-plans/new"
              element={
                <ProtectedRoute>
                  <ShootPlanWizard create />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shoot-plans/:id"
              element={
                <ProtectedRoute>
                  <ShootPlanWizard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute>
                  <Feedback />
                </ProtectedRoute>
              }
            />

            {/* Directory modules -- shared data, every department gets full access. */}
            <Route
              path="/brands"
              element={
                <ProtectedRoute>
                  <Brands />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team"
              element={
                <ProtectedRoute>
                  <Team />
                </ProtectedRoute>
              }
            />
            <Route
              path="/freelancers"
              element={
                <ProtectedRoute>
                  <Freelancers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/models"
              element={
                <ProtectedRoute>
                  <Models />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Navigate to="/dashboard" replace />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
